import { Dispatch, SetStateAction, useState } from 'react';
import * as yup from 'yup';
import { Hospital } from 'types/hospital';
import { cnpjValidator } from 'helpers/cnpjValidator';
import { sanitizeDocument } from 'helpers/sanitizeDocument';

export type HospitalValidation = {
  company_name?: string;
  company_trade_name?: string;
  document_number?: string;
};

type UseHospitalValidation = [
  HospitalValidation,
  Dispatch<SetStateAction<HospitalValidation>>,
  (hospital: Hospital) => Promise<void>,
];

export function useHospitalValidation(): UseHospitalValidation {
  async function handleValidation(hospital: Hospital) {
    const schema = yup.object().shape({
      document_number: yup
        .string()
        .required('O CNPJ é obrigatório')
        .transform((value, originalValue) => {
          return sanitizeDocument(originalValue);
        })
        .required('O CNPJ é obrigatório')
        .test('docValidation', 'CNPJ inválido', value => {
          if (!value) return false;

          const cnpj = cnpjValidator(value);

          return cnpj;
        }),
      company_trade_name: yup.string().required('O nome fantasia da empresa é obrigatório'),
      company_name: yup.string().required('O nome da empresa é obrigatório'),
    });

    try {
      await schema.validate(hospital);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<HospitalValidation>({});
  return [validation, setValidation, handleValidation];
}
